import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  forwardRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
  Validator,
} from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { RxIconComponent } from '../rx-icon/rx-icon.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'rx-search',
  templateUrl: './rx-search.component.html',
  styleUrls: ['./rx-search.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RxIconComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RxSearchComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RxSearchComponent),
      multi: true,
    },
  ],
})
export class RxSearchComponent implements OnDestroy, ControlValueAccessor, Validator {
  private destroyed$: Subject<boolean> = new Subject<boolean>();

  @Input() id = 'item' + Math.random().toString(36).substring(2);
  @Input() config: any;
  @Input() placeholder: string;
  @Input() icon = 'search';
  @Input() altIcon = 'close';
  @Input() busyIcon = 'icon-spinner';
  @Input() busy = false;
  @Input() isIconStart = false;
  @Input() disabled = false;
  @Input() showIcons = true;
  @ViewChild('input') input: ElementRef;
  @Output() searchChanged = new EventEmitter<string>();

  private _value: string;
  get value(): any {
    return this._value;
  }
  set value(val: any) {
    this._value = val;
    this.valueModel.next(this.value);
  }

  private valueModel: Subject<string> = new Subject<string>();

  constructor() {
    // Delayed search
    this.valueModel.pipe(debounceTime(500), takeUntil(this.destroyed$)).subscribe((data) => {
      this.onChange(this.value);
      this.searchChanged.emit(this.value);
    });
  }

  // input changes.
  onChange = (value: string) => {};

  // touched/clicked.
  onTouched = () => {};

  // Register for change
  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  // Register for touch/click
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // Update the model and changes
  writeValue(value: string): void {
    if (this._value !== value) {
      this._value = value;
      this.valueModel.next(value);
    }
  }

  // validate
  public validate(control: FormControl): any {
    return null;
  }

  onReset($event) {
    this.value = null;
    this.valueModel.next(this.value);
    this.onChange(this.value);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
